/*
 * Author: Harper Yan
 * File Created: Tuesday, 24-07-16 03:59 pm
 * Last Modified: Friday, 24-07-26 11:39 am, by Harper Yan
 */

import {
  listItemButtonClasses,
  listItemClasses,
  listItemTextClasses,
} from '@mui/material';
import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material/styles';

type ListThemeOptions = {
  defaultProps?: ComponentsProps['MuiList'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiList'];
  variants?: ComponentsVariants<Theme>['MuiList'];
};

type ListItemThemeOptions = {
  defaultProps?: ComponentsProps['MuiListItem'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiListItem'];
  variants?: ComponentsVariants<Theme>['MuiListItem'];
};

type ListItemButtonThemeOptions = {
  defaultProps?: ComponentsProps['MuiListItemButton'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiListItemButton'];
  variants?: ComponentsVariants<Theme>['MuiListItemButton'];
};

type ListItemTextThemeOptions = {
  defaultProps?: ComponentsProps['MuiListItemText'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiListItemText'];
  variants?: ComponentsVariants<Theme>['MuiListItemText'];
};

const MuiList: ListThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      width: '100%',
      padding: '0',
      color: '#9EA8B6',
    }),
  },
};

const MuiListItem: ListItemThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '16px 20px',
      color: '#9EA8B6',
    }),
  },
};

const MuiListItemButton: ListItemButtonThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '16px 20px',
      color: '#9EA8B6',
    }),
  },
};

const MuiListItemText: ListItemTextThemeOptions = {
  styleOverrides: {
    root: ({ theme }) => ({
      color: '#9EA8B6',
      fontSize: '14px',
      fontWeight: 400,
    }),
  },
};

const List = {
  MuiList,
  MuiListItemButton,
  MuiListItem,
  MuiListItemText,
};

export default List;
